import { render, staticRenderFns } from "./MyBuyList.vue?vue&type=template&id=7c98ebc6&scoped=true&"
import script from "./MyBuyList.vue?vue&type=script&lang=js&"
export * from "./MyBuyList.vue?vue&type=script&lang=js&"
import style0 from "./MyBuyList.vue?vue&type=style&index=0&id=7c98ebc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c98ebc6",
  null
  
)

export default component.exports